import { css } from "lit";
import { tabletsAndSmaller } from "./script/common/breakpoints";

export const indexStyles = css`

    @media print {
        app-header {
            display: none;
        }
    }

    main {
        padding: 16px;
        margin-bottom: 50px; /** needed to give some spacing between main content and the fixed footer */

        @media print {
            padding: 0;
        }
    }

    app-footer {
        /* Web Awesome removed its z-index design tokens in favor of cascade
           layers / stacking contexts. app-footer is position: fixed (see footer
           styles), which already stacks it above the in-flow page content. */
    }

    ${tabletsAndSmaller()} {
        main {
            padding: 0 4px 16px 4px;
            margin-top: 30px;
        }
    }

    #routerOutlet {
        position: relative; /* relative so that transitioned in/out pages won't cause scrollbar */
    }

    #routerOutlet > * {
        width: 100% !important;
    }

    #routerOutlet > .entering {
        position: fixed;
        animation: 160ms fadeIn linear;
    }

    #routerOutlet > .leaving {
        position: fixed;
        animation: 160ms fadeOut ease-in-out;
    }

    @keyframes fadeIn {
        from {
            opacity: 0.2;
        }

        to {
            opacity: 1;
        }
    }

    @keyframes fadeOut {
        from {
            opacity: 1;
        }

        to {
            opacity: 0;
        }
    }
`;